var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrderbookAll = function SvgOrderbookAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00049 17.9999H13.0005",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0005 5.99988L11.0005 5.99988",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00049 14.9335H11.3135C11.4429 14.9335 11.5673 14.8832 11.6605 14.7934L13.0248 13.478C13.2694 13.2421 13.6731 13.3137 13.8216 13.6194L15.5035 17.0816C15.6852 17.4557 16.2175 17.4574 16.4016 17.0845L18.2809 13.2785C18.3652 13.1079 18.539 12.9999 18.7292 12.9999H20.0005",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0005 9.45302L12.6561 9.45302C12.5456 9.45302 12.4383 9.48963 12.3508 9.55712L10.923 10.6585C10.6869 10.8406 10.345 10.7769 10.1902 10.5221L8.47525 7.69794C8.28136 7.37866 7.81858 7.37699 7.62239 7.69485L5.729 10.7625C5.63793 10.91 5.47691 10.9999 5.30352 10.9999L4.00049 10.9999",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
};
export default SvgOrderbookAll;